// https://confluence.sephora.com/wiki/spaces/ILLUMINATE/pages/558304849/BI+Phone+-+Phase+2+-+Quick+Links+and+Documentation#BIPhonePhase2QuickLinksandDocumentation-AuthService

import ufeApi from 'services/api/ufeApi';

/**
 * Validates MFA (phone or email) against backend service
 * @param {string} phone - Optional, mandatory for mfaMode=phone
 * @param {string} email - Mandatory
 * @param {string} mfaMode - Mandatory. Possible values: "phone", "email"
 * @returns {Promise} - Resolves with response data, rejects with error details
 */
function validateMFAEmailPhone(phone, email, mfaMode) {
    const payload = {
        email,
        mfaMode,
        ...(phone && { phone })
    };

    return ufeApi
        .makeRequest('/gway/v1/dotcom/auth/v1/validateUser', {
            method: 'POST',
            body: JSON.stringify(payload),
            headers: {
                'Content-type': 'application/json',
                'x-requested-source': 'web',
                'x-api-version': 1
            }
        })
        .then(response => {
            // Check for errors array
            if (response?.errors) {
                return Promise.reject(response.errors[0]);
            }

            // Check for errorCode in response
            if (response?.errorCode) {
                return Promise.reject(response);
            }

            // Check for HTTP error status
            if (response?.responseStatus >= 400) {
                return Promise.reject(response);
            }

            return response;
        });
}

/**
 * Validates OTP against backend service
 * @param {string} email - Mandatory
 * @param {string} otpCode - Mandatory - OPT code user provided on FE
 * @param {string} mfaMode - Mandatory. Possible values: "phone", "email"
 * @param {string} keepSignedIn - // Optional - will be used to generate JWT tokens, should be true if user selected "Stay signed in" during login
 * @returns {Promise}
 */
function mfaVerifyOTP(email, otpCode, mfaMode, keepSignedIn) {
    const payload = {
        email,
        otpCode,
        mfaMode,
        ...(keepSignedIn && { keepSignedIn })
    };

    return ufeApi
        .makeRequest('/gway/v1/dotcom/auth/v1/verifyOTP', {
            method: 'POST',
            body: JSON.stringify(payload),
            headers: {
                'Content-type': 'application/json',
                'x-requested-source': 'web',
                'x-api-version': 1
            }
        })
        .then(response => {
            // Check for errors array
            if (response?.errors) {
                return Promise.reject(response.errors[0]);
            }

            // Check for errorCode in response
            if (response?.errorCode) {
                return Promise.reject(response);
            }

            // Check for HTTP error status
            if (response?.responseStatus >= 400) {
                return Promise.reject(response);
            }

            return response;
        });
}

export default {
    validateMFAEmailPhone,
    mfaVerifyOTP
};
